import React from 'react';
import { Grid } from '@nextiva/next-ui-components';
import * as LaunchpadTypes from 'types/Launchpad';
import * as LaunchpadConstants from 'constants/launchpad';
import { LaunchpadTile } from '../Tile/Tile';

const TEST_ID = `${LaunchpadConstants.TEST_ID}-Grid`;

export interface LaunchpadGridProps {
  tileDefs: LaunchpadTypes.GridTileDef[];
}

export const LaunchpadGrid = ({ tileDefs = [] }) => (
  <Grid container spacing={2} data-testid={TEST_ID}>
    {tileDefs.map((t) => (
      <Grid item xs={3} key={t.id}>
        <LaunchpadTile tileDef={t} />
      </Grid>
    ))}
  </Grid>
);
